// extracted by mini-css-extract-plugin
export default {"article":"AppHeaderTeamItem_article_CVIzP","head":"AppHeaderTeamItem_head_zn16N","link":"AppHeaderTeamItem_link_jtV2p","img_wrapper":"AppHeaderTeamItem_img_wrapper_cQIih"};